import React from "react";

import { PenScanningCardsView } from "components/ScanningPenCards";

import { PenTypes } from "constants/auctionPens";

export const ArrivalScanningView = () => (
  <PenScanningCardsView penType={PenTypes.RECEIVING} />
);
